/* Risify collection sort boxes (RSFY-859).

   Desktop: the sort select lies invisibly over a box that shows the chosen
   option as text; this keeps that text in step with the select.

   Phones: the Sort box of the Risify collection toolbar. The
   Figma mobile toolbar puts a Filter button and a Sort box side by side, so
   the drawer opens filters only. The box's select mirrors the drawer's own
   sort select (SortBy-mobile) and hands every choice to it, so Dawn's
   facets.js submits the sort together with the drawer's filters as usual.
   facets.js re-renders that select after each change, so it is looked up
   on every use and followed through document-level listeners. */
if (!customElements.get('risify-mobile-sort')) {
  class RisifyMobileSort extends HTMLElement {
    connectedCallback() {
      this.select = this.querySelector('select');
      this.value = this.querySelector('[data-sort-value]');
      if (!this.select) return;

      this.select.addEventListener('change', () => {
        this.show();
        const drawerSelect = document.getElementById('SortBy-mobile');
        if (!drawerSelect || drawerSelect.value === this.select.value) return;
        drawerSelect.value = this.select.value;
        drawerSelect.dispatchEvent(new Event('input', { bubbles: true }));
      });

      /* a sort chosen in the drawer's own select */
      this.follow = (event) => {
        if (event.target.id !== 'SortBy-mobile') return;
        this.select.value = event.target.value;
        this.show();
      };
      document.addEventListener('change', this.follow);
      document.addEventListener('input', this.follow);
    }

    disconnectedCallback() {
      document.removeEventListener('change', this.follow);
      document.removeEventListener('input', this.follow);
    }

    show() {
      const option = this.select.options[this.select.selectedIndex];
      if (option && this.value) this.value.textContent = option.textContent.trim();
    }
  }

  customElements.define('risify-mobile-sort', RisifyMobileSort);
}

document.addEventListener('change', (event) => {
  if (event.target.id !== 'SortBy') return;
  const value = event.target.closest('.facet-filters__field')?.querySelector('[data-sort-value]');
  const option = event.target.options[event.target.selectedIndex];
  if (value && option) value.textContent = option.textContent.trim();
});
